import { THomeGroupType } from "src/data/homeGroups/types/homeGroupTypes"
import { THomeType } from "src/data/homes/types/homeTypes"

import { usePostTrackEventWithParams } from "./analyticsQueries"

export type THomegroupEventTypes =
  | THomegroupLocationEventTypes
  | THomegroupBuildingEventTypes

function usePostHomegroupTrackingEvent<TEventProperties>(
  event: THomegroupEventTypes
) {
  return usePostTrackEventWithParams<THomegroupEventTypes, TEventProperties>({
    event,
  })
}

type THomegroupLocationEventTypes =
  | "Change Location Address Clicked"
  | "Add Location Address Clicked"
  | "Add Location Address Initiated"
  | "Add Location Address Confirmed"

export function usePostHomegroupChangeAddressClicked() {
  const x = usePostHomegroupTrackingEvent("Change Location Address Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostHomegroupAddAddressClicked() {
  const x = usePostHomegroupTrackingEvent("Add Location Address Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostHomegroupAddAddressInitiated() {
  const x = usePostHomegroupTrackingEvent("Add Location Address Initiated")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostHomegroupAddAddressConfirmed() {
  const x = usePostHomegroupTrackingEvent("Add Location Address Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

type THomegroupBuildingEventTypes =
  | "Create Building Clicked"
  | "Create Building Initiated"
  | "Convert Homegroup Initiated"
  | "Convert Homegroup Confirmed"
  | "Building Address Initiated"
  | "Building Address Confirmed"
  | "Create Building Confirmed"
  | "Add Units to Building Clicked"
  | "Create New Units Clicked"
  | "Create New Units Initiated"
  | "Create New Units Info Filled"
  | "Create New Units Settings Picked"
  | "Create New Units Confirmed"
  | "Add Existing Units Clicked"
  | "Import Unit Clicked"
  | "Import Unit Initiated"
  | "Import Unit File Uploaded"
  | "Import Unit Reviewed"
  | "Import Unit Confirmed"
  | "Add Existing Units Initiated"
  | "Add Existing Units Confirmed"
  | "Unit Removed from Building"

export function usePostConvertHomegroupInitiated() {
  return usePostHomegroupTrackingEvent<{
    type: THomeGroupType
  }>("Convert Homegroup Initiated")
}

export function usePostConvertHomeGroupCompleted() {
  return usePostHomegroupTrackingEvent<{
    type: THomeGroupType
  }>("Convert Homegroup Confirmed")
}

export function usePostCreateBuildingClicked() {
  const x = usePostHomegroupTrackingEvent("Create Building Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateBuildingInitiated() {
  const x = usePostHomegroupTrackingEvent("Create Building Initiated")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostBuildingAddressInitiated() {
  const x = usePostHomegroupTrackingEvent("Building Address Initiated")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostBuildingAddressConfirmed() {
  const x = usePostHomegroupTrackingEvent("Building Address Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateBuildingConfirmed() {
  const x = usePostHomegroupTrackingEvent("Create Building Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostAddUnitsToBuildingClicked() {
  const x = usePostHomegroupTrackingEvent("Add Units to Building Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateNewUnitsClicked() {
  const x = usePostHomegroupTrackingEvent("Create New Units Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostAddExistingUnitsClicked() {
  const x = usePostHomegroupTrackingEvent("Add Existing Units Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostImportUnitClicked() {
  const x = usePostHomegroupTrackingEvent("Import Unit Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostImportUnitInitiated() {
  const x = usePostHomegroupTrackingEvent("Import Unit Initiated")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostImportUnitFileUploaded() {
  const x = usePostHomegroupTrackingEvent("Import Unit File Uploaded")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostImportUnitReviewed() {
  const x = usePostHomegroupTrackingEvent("Import Unit Reviewed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostImportUnitConfirmed() {
  const x = usePostHomegroupTrackingEvent("Import Unit Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostAddExistingUnitsInitiated() {
  const x = usePostHomegroupTrackingEvent("Add Existing Units Initiated")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostAddExistingUnitsConfirmed() {
  const x = usePostHomegroupTrackingEvent("Add Existing Units Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostUnitRemovedFromBuilding() {
  const x = usePostHomegroupTrackingEvent("Unit Removed from Building")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateNewUnitsInitiated() {
  return usePostHomegroupTrackingEvent<{
    type: THomeType
  }>("Create New Units Initiated")
}

export function usePostCreateNewUnitsInfoFilled() {
  const x = usePostHomegroupTrackingEvent("Create New Units Info Filled")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateNewUnitsSettingsPicked() {
  const x = usePostHomegroupTrackingEvent("Create New Units Settings Picked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}

export function usePostCreateNewUnitsConfirmed() {
  const x = usePostHomegroupTrackingEvent("Create New Units Confirmed")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}
